import { render, staticRenderFns } from "./DossierDetailsView.vue?vue&type=template&id=0ec63d36&scoped=true"
import script from "./DossierDetailsView.vue?vue&type=script&lang=ts"
export * from "./DossierDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./DossierDetailsView.vue?vue&type=style&index=0&id=0ec63d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec63d36",
  null
  
)

export default component.exports